import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import dynamic from 'next/dynamic';
import $ from 'jquery';

const OwlCarousel = dynamic(() => import(`@/componentWebs/Global/OwlCarousel`), {
  ssr: false,
  loading: () => null,
});

const pageSize = 40;

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataProvinces: [],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch({
      type: 'webs/fetchLazyLoading',
      payload: {
        filter: {
          // isInternational: "0"
        },
        // sort: ['countrieName', 'asc'],
        range: [0, pageSize - 1],
        // attributes: `id,countrieName`,
      },
      callback: res => {
        if (res.success) {
          this.setState({
            dataProvinces: (res && res.result && res.result.list) || [],
          });
        }
      },
    });
  }

  render() {
    const { dataAd } = this.props;
    const { dataProvinces } = this.state;

    return (
      <>
        <div className="khachSan__diadiem" onClick={this.handleSearch}>
          {dataProvinces && dataProvinces.length > 0 && (
            <div className="box-provinces-list">
              <OwlCarousel
                className="owl-carousel"
                items={8}
                margin={30}
                dots={false}
                slideBy={1}
                nav
                navText={[
                  '<img src="/static/vietnamTickets/images/leftnavigationbutton.png" />',
                  '<img src="/static/vietnamTickets/images/rightnavigationbutton.png" />',
                ]}
              // loop
              >
                {dataProvinces.map(item => (
                  <div className="box-provinces" key={item.id}>
                    <img
                      src={
                        (item.images &&
                          item.images[0] &&
                          item.images[0].file &&
                          getResponsiveImage(item.images[0].file)) ||
                        '/static/vietnamTickets/images/unimage.png'
                      }
                      alt={item.countrieName}
                      className="khachSan__diadiem__img lazyload"
                    />
                    <div className="text">{item.countrieName}</div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default Index;
